export default "__VITE_ASSET__D2HrEL4z__"